const TableFileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_2906_30976)">
        <path
          d="M11.667 2.5V5.83333C11.667 6.05435 11.7548 6.26631 11.9111 6.42259C12.0674 6.57887 12.2793 6.66667 12.5003 6.66667H15.8337"
          stroke="currentColor"
          stroke-width="0.833333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.9465 17.5C7.69209 17.5 5.83366 17.5 5.83366 17.5C5.39163 17.5 4.96771 17.3244 4.65515 17.0118C4.34259 16.6993 4.16699 16.2754 4.16699 15.8333V4.16667C4.16699 3.72464 4.34259 3.30072 4.65515 2.98816C4.96771 2.67559 5.39163 2.5 5.83366 2.5H11.667L15.8337 6.66667V9.98248"
          stroke="currentColor"
          stroke-width="0.833333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g clip-path="url(#clip1_2906_30976)">
          <path
            d="M16.1141 11.6074H13.5551C13.3289 11.6074 13.1119 11.6973 12.952 11.8573C12.792 12.0172 12.7021 12.2342 12.7021 12.4604V16.7253C12.7021 16.9515 12.792 17.1685 12.952 17.3285C13.1119 17.4884 13.3289 17.5783 13.5551 17.5783H17.82C18.0463 17.5783 18.2632 17.4884 18.4232 17.3285C18.5832 17.1685 18.673 16.9515 18.673 16.7253V14.1664"
            stroke="currentColor"
            stroke-width="0.833333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.6875 14.5931L19.5259 10.7546"
            stroke="currentColor"
            stroke-width="0.833333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.3936 10.7546H19.5267V12.8878"
            stroke="currentColor"
            stroke-width="0.833333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2906_30976">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
        <clipPath id="clip1_2906_30976">
          <rect
            width="10.2358"
            height="10.2358"
            fill="currentColor"
            transform="translate(10.9961 9.04858)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TableFileIcon;
